// 납입지시 - 시작차 출하관리
import { Route, Switch } from 'react-router-dom';
import { lazy, Suspense } from 'react';


const ROM81 = lazy(() => import('@/pages/A04/ROM81'));  // 납품서발행
const ROM82 = lazy(() => import('@/pages/A04/ROM82'));  // 발행취소/재인쇄
const ROM84 = lazy(() => import('@/pages/A04/ROM84'));  // 부품식별표
const ROM85 = lazy(() => import('@/pages/A04/ROM85'));  // 시작차 입고현황
const ROM86 = lazy(() => import('@/pages/A04/ROM86'));  // 시작차 발주현황

function A04() {
  return ( 
    <Suspense fallback={null}>
      <Switch>
        <Route path="/A04/ROM81" component={ROM81} />
        <Route path="/A04/ROM82" component={ROM82} />
        <Route path="/A04/ROM84" component={ROM84} />
        <Route path="/A04/ROM85" component={ROM85} />
        <Route path="/A04/ROM86" component={ROM86} />
      </Switch>
    </Suspense>
  );
}

export default A04;
